import { useMemo } from 'react';
import {
  BROWSE_ONLY_BOOKING_ACCOUNT_HOME,
  isBookingToolOpenOnBrowseOnlyCountry,
} from '@/core/constants/booking-tool-markets';
import useFeatureFlag from '@/ui/hooks/use-feature-flag';
import useIsNonEvaCountry from '@/ui/hooks/use-is-non-eva-country';
import useLocaleParams from '@/ui/hooks/use-locale-params';

/**
 * Browse-only markets with an open booking tool (e.g. Dubai): show header account
 * and limit account navigation to bookings — no cart or shop account overview.
 */
const useBrowseOnlyBookingAccountAccess = () => {
  const isNonEvaCountry = useIsNonEvaCountry();
  const isBookingToolEnabled = useFeatureFlag('FEATURE_BOOKING_TOOL');
  const { country } = useLocaleParams();

  return useMemo(() => {
    const isBrowseOnlyBookingAccountMarket =
      isBookingToolEnabled &&
      isBookingToolOpenOnBrowseOnlyCountry(country);

    return {
      isBrowseOnlyBookingAccountMarket,
      showHeaderAccountLink:
        !isNonEvaCountry || isBrowseOnlyBookingAccountMarket,
      showHeaderCart: !isNonEvaCountry,
      accountEntryHref: isBrowseOnlyBookingAccountMarket
        ? BROWSE_ONLY_BOOKING_ACCOUNT_HOME
        : '/account',
    };
  }, [country, isBookingToolEnabled, isNonEvaCountry]);
};

export default useBrowseOnlyBookingAccountAccess;
